export default __webpack_public_path__ + "static/media/double-border-right.9374a89d.svg";